import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Dashboard from './Components/Pages/Dashboard';
import 'bootstrap/dist/css/bootstrap.min.css'
import LoginForm from './Components/Auth/login';
import UserDelete from './Components/UserDelete/UserDelete';
import Form from './Components/Pages/Form';
import AgencyList from './Components/Pages/AgencyList';
import AgencyLogin from './Components/Auth/AgencyLogin';
import ProtectedRoute from './Components/Auth/ProtectedRoute';
import CardUrl from './Components/Pages/CardUrl';
import AgencyDashboard from './Components/Pages/AgencyDashboard';
import Offers from './Components/Pages/Offers';
import OffersPage from './Components/Pages/OffersPage';
import Payment from './Components/Pages/Payment';
import DirectoryLevel from './Components/Pages/DirectoryLevel';




function App() {
  return (
    <Router>
      <Routes>
        <Route path='/delete' element={<UserDelete />} />
        <Route path="/" element={<LoginForm />} />
        <Route path="/dashboard/dashboard" element={<Dashboard />} />

        <Route path="/form" element={<Form />} />
        <Route path="/directory-level/upgrade" element={<DirectoryLevel />} />

        {/* <Route path="/agency-list" element={<AgencyList />} /> */}
        <Route path="/agency-login" element={<AgencyLogin />} />
        <Route path="/agency-dashboard" element={<ProtectedRoute> <AgencyDashboard /> </ProtectedRoute>} />
        <Route path="/agency-list" element={<ProtectedRoute> <AgencyList /> </ProtectedRoute>} />
        <Route path="/agency-offers" element={<ProtectedRoute> <Offers /> </ProtectedRoute>} />
        <Route path="/agency-payment" element={<ProtectedRoute> <Payment /> </ProtectedRoute>} />
        {/* <Route path="/agency-offers" element={<Offers />} /> */}
        <Route path="/offers/:id" element={<OffersPage />} />

        <Route path="/cardurl/:code" element={<CardUrl />} />
      </Routes>
    </Router>
  );
}

export default App;
